import { useMutation, useQuery } from "react-query";
import {
  downloadDeliverable,
  downloadInput,
  getBatchDetailsWithSkusForAdmin,
  listBatchesForAdmin,
  listSourcesForAdmin,
  listUsersForAdmin,
  resendToSegregation,
  setClientClarificationPending,
} from "../apis/admin";

const queryOpts = { refetchOnWindowFocus: false };
const body = (res) => res?.data;

export const useAdminSources = ({ enabled = true } = {}) =>
  useQuery(["admin_sources"], listSourcesForAdmin, {
    ...queryOpts,
    enabled,
    select: (res) => body(res)?.data || [],
  });

export const useAdminUsers = (params, { enabled = true } = {}) =>
  useQuery(["admin_users", params], () => listUsersForAdmin(params), {
    ...queryOpts,
    enabled,
    select: (res) => body(res)?.users || [],
  });

export const useAdminBatches = (params, { enabled = true } = {}) =>
  useQuery(["admin_batches", params], () => listBatchesForAdmin(params), {
    ...queryOpts,
    enabled,
    select: (res) => ({
      batches: body(res)?.data || [],
      totalCount: body(res)?.totalCount || 0,
    }),
  });

export const useAdminBatchSkus = (batchId, params, { enabled = true } = {}) =>
  useQuery(
    ["admin_batch_skus", batchId, params],
    () => getBatchDetailsWithSkusForAdmin(batchId, params),
    {
      ...queryOpts,
      enabled: Boolean(batchId) && enabled,
      select: (res) => ({
        batch: body(res)?.batch,
        skus: body(res)?.skus || [],
        totalCount: body(res)?.totalCount || 0,
      }),
    }
  );

export const useDownloadInput = (onSuccess, onError) =>
  useMutation(downloadInput, { onSuccess, onError });

export const useDownloadOutput = (onSuccess, onError) =>
  useMutation(downloadDeliverable, { onSuccess, onError });

export const useResendToSegregation = (onSuccess, onError) =>
  useMutation(resendToSegregation, { onSuccess, onError });

export const useSetClientClarificationPending = (onSuccess, onError) =>
  useMutation(setClientClarificationPending, { onSuccess, onError });
